/**
 * PgcStash — client-side pending-work stash shared by every upload tool.
 *
 * A File object survives navigation in IndexedDB; this stashes the user's
 * files AND form options when they hit the credit wall, so the post-checkout
 * return (?paid=1) restores the exact pre-purchase state instead of making
 * them re-photograph/re-select.
 *
 *   PgcStash.save('crop', { files: { image: File }, options: { crop_level } })
 *   PgcStash.load('crop').then(p => { …PgcStash.attachFile('image', p.files.image)… })
 *   PgcStash.clear('crop')
 *
 * Server-side work (scans, detected crops, selections) doesn't need this —
 * it rides the pending_actions table via ?resume=<token>. This stash covers
 * work that never reached the server (file picked, form filled, 402/preflight
 * upsell fired before submit).
 */
(function (window) {
    'use strict';

    var DB = 'pgc-work-stash';
    var STORE = 'items';
    // 2h — checkout detours (browsing packages, card entry) can take a while.
    var TTL_MS = 2 * 60 * 60 * 1000;

    var PAID_RETURN = (function () {
        try { return new URLSearchParams(location.search).get('paid') === '1'; } catch (_) { return false; }
    })();

    function store(mode) {
        return new Promise(function (resolve, reject) {
            var req = indexedDB.open(DB, 1);
            req.onupgradeneeded = function () { req.result.createObjectStore(STORE); };
            req.onsuccess = function () { resolve(req.result.transaction(STORE, mode).objectStore(STORE)); };
            req.onerror = function () { reject(req.error); };
        });
    }

    function save(tool, payload) {
        if (!window.indexedDB || !tool || !payload) return Promise.resolve(false);
        payload.tool = tool;
        payload.path = location.pathname;
        payload.ts = Date.now();
        return store('readwrite').then(function (s) { s.put(payload, tool); return true; }).catch(function () { return false; });
    }

    function load(tool) {
        if (!window.indexedDB || !tool) return Promise.resolve(null);
        return store('readonly').then(function (s) {
            return new Promise(function (resolve) {
                var g = s.get(tool);
                g.onsuccess = function () {
                    var p = g.result;
                    if (!p || p.path !== location.pathname || (Date.now() - p.ts) > TTL_MS) return resolve(null);
                    resolve(p);
                };
                g.onerror = function () { resolve(null); };
            });
        }).catch(function () { return null; });
    }

    function clear(tool) {
        if (!window.indexedDB || !tool) return;
        store('readwrite').then(function (s) { s.delete(tool); }).catch(function () {});
    }

    // Re-attach a stashed File to an <input type=file> via DataTransfer, then
    // fire `change` so the tool's normal select handler re-renders the preview.
    function attachFile(inputName, file) {
        if (!file) return false;
        var inp = document.querySelector('input[name="' + inputName + '"]');
        if (!inp || typeof DataTransfer === 'undefined') return false;
        try {
            var dt = new DataTransfer();
            dt.items.add(file);
            inp.files = dt.files;
            inp.dispatchEvent(new Event('change', { bubbles: true }));
            return true;
        } catch (_) { return false; }
    }

    window.PgcStash = { save: save, load: load, clear: clear, attachFile: attachFile, PAID_RETURN: PAID_RETURN };
})(window);
